// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"_yd_dZzBcrRT8NyTlYD_N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 137
// module chunks = 0